<template>
<div ref="MemberEdit" id="MemberEdit">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑会员</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="memberlist.length > 1 ? memberlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoToMember(false)">返回会员管理</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box" v-for="(item,index) in memberlist" :key="index">
            <div class="TTL-form-submit-box-title">会员-{{index+1}}</div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">会员头像</label>
                    <wcupload :option="{size:'large'}" :value="item.avar" 
                        @finish="(val)=> {
                            item.avar=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员名称<i>*</i></label>
                    <div class="TTL-input width350 TTL-form-input">
                    <el-input v-model="item.username" placeholder="请输入会员名称" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员手机<i>*</i></label>
                    <div class="TTL-input width350 TTL-form-input">
                    <el-input v-model="item.phone" placeholder="请输入会员手机" clearable />
                    </div>
                </el-form-item>
                <!-- <el-form-item>
                    <div class="TTL-button TTL-btn-option">
                    <el-button @click="AddPets(index)">添加宠物</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option">
                    <el-button type="del" @click="[delAllpet(index),SaveDataToBrowser]" v-if="item.pet.length > 0">删除全部宠物</el-button>
                    </div>
                    <el-table :data="item.pet" stripe="true" class="top30" v-if="item.pet.length > 0">
                        <el-table-column label="宠物图">
                            <template #default="scope">
                            <div class="TTL-image-box-small" @click.stop="uploadimages('pet',index,scope.$index)">
                            <el-image 
                            :src="scope.row.thumb ? scope.row.thumb : require('@/assets/icon/pet-gray.png')" 
                            fit="cover" 
                            />
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="宠物名称" align="center" min-width="200">
                            <template #default="scope">
                            <div class="TTL-input TTL-form-input">
                            <el-input v-model="scope.row.name" placeholder="请输入宠物名称" @change="SaveDataToBrowser" clearable />
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="宠物品种" align="center" min-width="200">
                            <template #default="scope">
                            <div class="TTL-select">
                            <el-select v-model="scope.row.breedid" placeholder="请选择宠物品种" @change="SaveDataToBrowser" filterable clearable>
                            <el-option v-for="(item,index) in breedlist" :key="index" :label="item.breedname" :value="item.id" />
                            </el-select>
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="宠物身高" align="center" min-width="200">
                            <template #default="scope">
                            <div class="TTL-input TTL-append TTL-form-input">
                            <el-input v-model="scope.row.height" placeholder="请填写宠物身高" @change="SaveDataToBrowser" clearable >
                            <template #append>cm</template>
                            </el-input>
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="宠物体重" align="center" min-width="200">
                            <template #default="scope">
                            <div class="TTL-input TTL-append TTL-form-input">
                            <el-input v-model="scope.row.weight" placeholder="请填写宠物体重" @change="SaveDataToBrowser" clearable >
                            <template #append>kg</template>
                            </el-input>
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="宠物生日" align="center" min-width="280">
                            <template #default="scope">
                            <div class="TTL-datetime">
                            <el-date-picker v-model="scope.row.birthday" type="date" value-format="YYYY-MM-DD" placeholder="请选择宠物生日" @change="SaveDataToBrowser" />
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="宠物性别" align="center" min-width="150">
                            <template #default="scope">
                            <div class="TTL-radio">
                            <el-radio-group v-model="scope.row.sex" class="ml-4" @change="SaveDataToBrowser">
                                <el-radio label="1"><el-image :src="require('@/assets/icon/man.png')" fit="cover" /></el-radio>
                                <el-radio label="2"><el-image :src="require('@/assets/icon/woman.png')" fit="cover" /></el-radio>
                            </el-radio-group>
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" fixed="right" min-width="120">
                            <template #default="scope">
                            <div class="TTL-button">
                            <el-button type="del" @click="[delpetinfo(index,scope.$index),SaveDataToBrowser]">删除</el-button>
                            </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item> -->
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Member/Member';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            addlimit: 10,        //单次新增限制
            updatetype:'',       //上传类型（member-会员头像，pet-宠物头像）
            uploadimageIndex:'', //获取当前上传图片的序号
            uploadpetIndex:'',   //上传会员宠物图片的序号
            breedlist:[],        //宠物品种信息
            memberlist:[
                {avar:'',username:'',phone:'',pet:[]},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetBreedInfos(); //获取宠物类型信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前已有会员信息正在编辑，执行此操作会覆盖当前数据，是否执行 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetMemberInfo(data.ids);
                }).catch(()=> {
                    
                });

            }else if(data.reload) { //浏览器重新刷新时执行的操作
                this.ParseDataFromBrowser(); //解析数据
            }else {
                this.GetMemberInfo(data.ids); //解析数据
            }
        },


        /** 保存新增会员信息 **/
        submitData() {
            //提交数据检测
            var result=this.CheckDataBeforeSubmit();
            if(result.error > 0) {this.$notice({title:'消息提示',message:result.message,type:'warning'});return false}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.memberlist.length;i++) data.push(this.memberlist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.MemberEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_MEMBER.EDIT_MEMBER({memberdata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.ClearDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.GoToMember(true); //返回会员列表
            });
        },


        /** 提交数据前进行数据检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(!this.memberlist || this.memberlist.length==0) {result={error:1,message:'请填写会员信息'};return result;}
            if(this.memberlist.length > this.addlimit) {result={error:1,message:'单次最后可以新增'+this.addlimit+'个会员'};return result;}
            var memberobj;
            var petobj;
            var memberindex=0;
            var petindex=0;
            for(var i;i<this.memberlist.length;i++) {
                memberindex++;
                petindex=0;
                memberobj=this.memberlist[i];
                if(!memberobj.username || memberobj.username=='') {result={error:1,message:'第'+memberindex+'个会员的会员名称不能为空'};return result;}
                if(!memberobj.phone || memberobj.phone=='') {result={error:1,message:'第'+memberindex+'个会员的会员手机不能为空'};return result;}
                if(memberobj.pet.length > 0) {
                    for(var ii;ii<memberobj.pet.length;ii++) {
                        petindex++;
                        petobj=memberobj.pet[ii];
                        if(!petobj.name || petobj.name=='') {result={error:1,message:'第'+memberindex+'个会员的第'+petindex+'个宠物的宠物名称不能为空'};return result;}
                        if(!petobj.breedid || petobj.breedid==0) {result={error:1,message:'第'+memberindex+'个会员的第'+petindex+'个宠物的宠物品种不能为空'};return result;}
                    }
                }
            }
            return result;
        },


        /** 上传图片 **/
        uploadimages(type,index,petindex) {
            this.type=type;                                       //上传图片类型
            this.uploadimageIndex=index;                          //标记当前上传图片序号
            this.petindex=petindex;                               //上传图片会员宠物序号
            var obj=document.querySelector('#TTLFiles');          //获取文件对象
            obj.click();                                          //点击触发上传图片
            obj.addEventListener('change',this.uploadimagedata);  //添加监听事件
        },


        /** 新增宠物 **/
        AddPets(index) {
            var data={thumb:'',name:'',breedid:'',breedname:'',height:'',weight:'',sex:'1',birthday:''};
            this.memberlist[index].pet.push(data);
            console.log(this.memberlist);
            this.SaveDataToBrowser(); //更新数据到浏览器
        },


        /** 删除会员下面的全部宠物 **/
        delAllpet(index) {
            this.memberlist[index].pet=[];
        },


        /** 删除会员下单个宠物 **/
        delpetinfo(index,petindex) {
            this.memberlist[index].pet.splice(petindex,1);
            this.SaveDataToBrowser();
        },


        /** 返回会员管理 **/
        GoToMember(isdel) {
            var navinfo={name:'会员管理',labelentry:'Member',components:'Member',isshow:false};
            var data={Method:''};
            if(isdel) data.delcomponents='EditMember';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        //////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////

        /** 获取会员信息 **/
        GetMemberInfo(ids) {
            //loading等待动画加载
            var editobj=document.getElementById("MemberEdit");
            this.$loading.openloading(editobj);
            var param={p:1,rollpage:100000,ids:ids,key:''};

            INTERFACE_MODEL_MEMBER.GET_MEMBER_INFO(param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(editobj);
                 var datas=res.data.list;
                 this.memberlist=[];
                 var obj;
                 var petobj;
                 var itempetobj;
                 var items=[];
                 var pets=[];
                 for(var i=0;i <  datas.length; i++) {
                     pets=[];
                     obj=datas[i];
                     petobj=datas[i].pet;
                     items={id:obj.id,avar:obj.avar,username:obj.username,phone:obj.phone,pet:[]};
                     for(var ii=0;ii < petobj.length;ii++) {
                         itempetobj=petobj[ii];
                         items.pet.push({
                             id:itempetobj.id,thumb:itempetobj.thumb,name:itempetobj.name,
                             breedid:itempetobj.breedid,breedname:itempetobj.breedname,
                             height:itempetobj.height,weight:itempetobj.weight,sex:itempetobj.sex.toString(),
                             birthday:itempetobj.birthday
                        });
                     }
                    this.memberlist.push(items);
                 }
                 this.SaveDataToBrowser(); //数据保存到浏览器
            });
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.memberlist);
            localStorage.setItem('editmemberdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('editmemberdata');
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetData() : this.memberlist=JSON.parse(data);
            console.log(this.memberlist);
        },

        /** 清空浏览器数据 **/
        ClearDataToBrowser() {
            localStorage.setItem('editmemberdata','');
            this.resetData(); //重置数据
        },

         /** 获取宠物类型信息 **/
        GetBreedInfos() {
            INTERFACE_MODEL_PETS.GET_PET_BREEDS_ALL({}).then((res) => {
                 if(res.status > 0) return false;
                 this.breedlist=res.data;
             });
        },

         /** 数据复位 **/
        resetData() {
            this.memberlist=[{avar:'',username:'',phone:'',pet:[]}];
        },

        /** 上传图片信息操作 **/
        uploadimagedata(e) {
            var _this=this;
            this.file=e.target.files[0];       //获取上传的图片
            e.target.value=null;                //清空数据
            document.querySelector('#TTLFiles').removeEventListener('change',this.uploadimagedata);  //解除监听事件

            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:this.file}).then((res) => {
                if(res.status > 0) return false;
                var url=_this.$ImageAddress+res.data.url; //获取图片链接
                if(_this.type=='member') _this.memberlist[this.uploadimageIndex].avar=url;
                if(_this.type=='pet') _this.memberlist[this.uploadimageIndex].pet[this.petindex].thumb=url;
                _this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },

        //////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.el-table thead th) {font-weight: 540 !important;letter-spacing: 1px;font-size: 13px;}
::v-deep(.el-table__empty-text) {font-size:13px !important;}
.TTL-image-box-small {overflow: hidden;cursor: pointer;}
::v-deep(.el-table .el-table__cell) {padding:15px 0 !important;}
</style>